var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.29,2.082h-2.013V1.609c0-0.392-0.318-0.71-0.71-0.71c-0.393,0-0.71,0.318-0.71,0.71v0.474H4.222V1.609 c0-0.392-0.318-0.71-0.71-0.71c-0.393,0-0.71,0.318-0.71,0.71v0.474H0.71C0.318,2.082,0,2.4,0,2.793v11.599 c0,0.392,0.318,0.71,0.71,0.71h14.58c0.393,0,0.71-0.318,0.71-0.71V2.793C16,2.4,15.682,2.082,15.29,2.082z M2.802,3.503v0.473 c0,0.392,0.318,0.71,0.71,0.71c0.393,0,0.71-0.318,0.71-0.71V3.503h7.635v0.473c0,0.392,0.318,0.71,0.71,0.71 c0.393,0,0.71-0.318,0.71-0.71V3.503h1.302v2.771H1.42V3.503H2.802z M1.42,13.681V6.984H14.58v6.697H1.42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.655,
    y: 8.426,
    width: 1.377,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.039,
    y: 8.426,
    width: 1.377,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.424,
    y: 8.426,
    width: 1.379,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.808,
    y: 8.426,
    width: 1.379,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.194,
    y: 8.426,
    width: 1.377,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.655,
    y: 10.639,
    width: 1.377,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.039,
    y: 10.639,
    width: 1.377,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.424,
    y: 10.639,
    width: 1.379,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.808,
    y: 10.639,
    width: 1.379,
    height: 1.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.194,
    y: 10.639,
    width: 1.377,
    height: 1.377
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.cdc6ca761b6410fe6049ea0fdb1b46f2.svg";
export { ForwardRef as ReactComponent };